import type { ResourceLock } from '../resources-lock/resource-lock'

export class AppointmentResource {
    resourceLockItemId: string
    start: Date
    end: Date
    createdAt: Date
    updatedAt: Date
    appointmentId: string
    resourcesLockId: string
    resourceLock: ResourceLock
}
